import React from 'react';
import { AreaChart, Area, ResponsiveContainer, XAxis, Tooltip, CartesianGrid } from 'recharts';
import { Container, SectionHeader, Card, StatCard } from '../ui';

// Section 6: stylized, on-brand product preview of the district dashboard.
// Sample data only - no real screenshots, no backend.
const TREND = [
  { m: 'Sep', v: 18 }, { m: 'Oct', v: 31 }, { m: 'Nov', v: 27 },
  { m: 'Dec', v: 22 }, { m: 'Jan', v: 35 }, { m: 'Feb', v: 41 }, { m: 'Mar', v: 47 },
];
const SCHOOLS = [
  { name: 'Edinburg High', sport: 'Football', sold: 1842, rev: '$14,736' },
  { name: 'McAllen Memorial', sport: 'Volleyball', sold: 612, rev: '$3,060' },
  { name: 'PSJA North', sport: 'Basketball', sold: 988, rev: '$5,928' },
  { name: 'Sharyland Pioneer', sport: 'Fine Arts', sold: 415, rev: '$2,905' },
];

const DashboardPreview = () => (
  <section className="bg-ink-50 py-16 sm:py-24">
    <Container>
      <SectionHeader
        align="center"
        eyebrow="Analytics & reporting"
        title="One dashboard for the whole district"
        subtitle="Tickets, revenue and attendance from every campus and program, live, in one place."
      />

      <Card className="mt-10 p-4 sm:p-6 shadow-lift">
        {/* window chrome */}
        <div className="flex items-center gap-1.5 px-1 pb-4">
          <span className="w-3 h-3 rounded-full bg-red-400" />
          <span className="w-3 h-3 rounded-full bg-amber-400" />
          <span className="w-3 h-3 rounded-full bg-emerald-400" />
          <span className="ml-3 text-xs text-ink-400">District Command Center</span>
        </div>

        {/* KPI row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <StatCard label="Tickets sold today" value="2,418" icon="🎟️" trend={{ dir: 'up', value: '12%' }} hint="vs yesterday" accent="#2451e0" />
          <StatCard label="Revenue today" value="$16.2k" icon="💵" trend={{ dir: 'up', value: '8%' }} hint="vs yesterday" accent="#16a34a" />
          <StatCard label="Active schools" value="9/13" icon="🏫" hint="with live events" accent="#f59e0b" />
          <StatCard label="Events this week" value="24" icon="📅" hint="across the district" accent="#7c3aed" />
        </div>

        {/* chart + table */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4">
          <Card className="p-5 lg:col-span-2">
            <div className="flex items-center justify-between mb-1">
              <h3 className="font-bold font-display text-ink-900">Attendance trend</h3>
              <span className="text-xs text-ink-400">Fans / month (thousands)</span>
            </div>
            <div className="h-44">
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={TREND} margin={{ top: 6, right: 4, left: -28, bottom: 0 }}>
                  <defs>
                    <linearGradient id="dp" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#2451e0" stopOpacity={0.35} />
                      <stop offset="100%" stopColor="#2451e0" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eef2f7" />
                  <XAxis dataKey="m" tick={{ fontSize: 12, fill: '#94a3b8' }} axisLine={false} tickLine={false} />
                  <Tooltip contentStyle={{ borderRadius: 12, border: '1px solid #e2e8f0', fontSize: 13 }} />
                  <Area type="monotone" dataKey="v" stroke="#2451e0" strokeWidth={2.5} fill="url(#dp)" />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Card>

          <Card className="p-5">
            <h3 className="font-bold font-display text-ink-900 mb-3">Top schools</h3>
            <div className="space-y-3">
              {SCHOOLS.map((s) => (
                <div key={s.name} className="flex items-center justify-between text-sm">
                  <div className="min-w-0">
                    <p className="font-semibold text-ink-800 truncate">{s.name}</p>
                    <p className="text-xs text-ink-400">{s.sport} · {s.sold} sold</p>
                  </div>
                  <span className="font-semibold text-ink-900">{s.rev}</span>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </Card>
      <p className="text-center text-xs text-ink-400 mt-3">Sample data shown for illustration.</p>
    </Container>
  </section>
);

export default DashboardPreview;
